import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=71d68930&scoped=true"
import script from "./Judge.vue?vue&type=script&lang=js"
export * from "./Judge.vue?vue&type=script&lang=js"
import style0 from "./Judge.vue?vue&type=style&index=0&id=71d68930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d68930",
  null
  
)

export default component.exports